export const GET_ALERT_INSTANCES = `
  query GetAlertInstances($companyId: Int!) {
    alert_instances(
      where: { company_id: { _eq: $companyId }, is_resolved: { _eq: false } }
      order_by: [
        { alert_type_config: { severity: asc } }
        { first_seen_at: desc }
      ]
    ) {
      id
      alert_type_code
      entity_type
      entity_id
      entity_label
      extra_data
      firm_id
      first_seen_at
      last_evaluated_at
      alert_type_config {
        category
        label_tr
        severity
      }
    }
  }
`;

export const GET_ALERT_CONFIGS = `
  query GetAlertConfigs {
    alert_configs(order_by: { alert_type_config: { category: asc } }) {
      id
      alert_type_code
      is_enabled
      send_email
      frequency
      updated_at
      alert_type_config {
        code
        category
        label_tr
        severity
        is_active
      }
      alert_config_targets {
        id
        target_type
        target_value
      }
    }
  }
`;

export const GET_ENTITY_ALERT_IDS = `
  query GetEntityAlertIds($companyId: Int!, $entityType: String!) {
    alert_instances(
      where: {
        company_id: { _eq: $companyId }
        entity_type: { _eq: $entityType }
        is_resolved: { _eq: false }
      }
    ) {
      entity_id
      alert_type_config { severity }
    }
  }
`;

export const GET_ALERT_MAIL_LOGS = `
  query GetAlertMailLogs($limit: Int = 50) {
    alert_mail_logs(order_by: { sent_at: desc }, limit: $limit) {
      id
      alert_type_code
      recipient_email
      trigger_type
      instance_count
      status
      sent_at
    }
  }
`;

export const GET_UNREAD_ALERT_COUNT = `
  query GetUnreadAlertCount($companyId: Int!) {
    alert_instances_aggregate(
      where: { company_id: { _eq: $companyId }, is_resolved: { _eq: false } }
    ) {
      aggregate { count }
    }
  }
`;

export const GET_MY_DISMISSALS = `
  query GetMyDismissals($userId: Int!) {
    alert_dismissals(where: { user_id: { _eq: $userId } }) {
      id
      alert_instance_id
      dismissed_at
    }
  }
`;
